import callApi from '../../util/apiCaller';
// Export Constants
export const FETCH_PIPELINE_STATS = 'FETCH_PIPELINE_STATS';
export const FETCH_PIPELINE_CONVERSION_OPPORTUNITIES = 'FETCH_PIPELINE_CONVERSION_OPPORTUNITIES';

export function fetchStats(criteria) {
  return (dispatch) => {
    const empty = {
      stats: {},
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
      accounts: {},
      stages: [],
    };
    dispatch({
      type: FETCH_PIPELINE_STATS, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'products',
      'repTypes',
      'repRegions',
      'logHistories',
      'stageHistories',
      'lineItems',
      'opportunityCompetitors',
    ];
    const { team } = criteria;
    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete criteria.team;
    const p = callApi(`search/pipeline?include=${included.join(',')}${teamId}`, 'POST', criteria);

    p.then(
      ({
        stats, opportunities, owners, stages, accounts,
      }) => dispatch({
        type: FETCH_PIPELINE_STATS, stats, opportunities, owners, stages, accounts, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: FETCH_PIPELINE_STATS, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}

export function resetStats() {
  return (dispatch) => {
    const empty = {
      stats: {},
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
      stages: [],
    };
    return new Promise((resolve) => {
      dispatch({
        type: FETCH_PIPELINE_STATS, ...empty,
      });
      resolve(true);
    });
  };
}


export function fetchConversionOpportunities(criteria) {
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
    };
    dispatch({
      type: FETCH_PIPELINE_CONVERSION_OPPORTUNITIES, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'accounts',
      'products',
      'repTypes',
      'repRegions',
      'stageHistories',
      'logHistories',
      'lineItems',
      'opportunityCompetitors',
    ];
    const { team } = criteria;
    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete criteria.team;
    const p = callApi(`search/pipeline/conversion?include=${included.join(',')}${teamId}`, 'POST', criteria);
    p.then(
      results => dispatch({
        type: FETCH_PIPELINE_CONVERSION_OPPORTUNITIES, ...results, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: FETCH_PIPELINE_CONVERSION_OPPORTUNITIES, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}

export function resetConversionOpportunities() {
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
    };
    return new Promise((resolve) => {
      dispatch({
        type: FETCH_PIPELINE_CONVERSION_OPPORTUNITIES, ...empty,
      });
      resolve(true);
    });
  };
}
